const timeout = 400

export default timeout
